/**
 * This uncompressed file is not referenced by the theme,
 * it is only included as a reference.
 *
 * If you need help with our code, contact us:
 * hello@altanddot.com
 */



'use strict';

if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2

            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

if (Element && !Element.prototype.matches) {
    var proto = Element.prototype;
    proto.matches = proto.matchesSelector ||
        proto.mozMatchesSelector || proto.msMatchesSelector ||
        proto.oMatchesSelector || proto.webkitMatchesSelector;
}

// add utilities
var util = {
    keyCodes: {
        UP: 38,
        DOWN: 40,
        LEFT: 37,
        RIGHT: 39,
        HOME: 36,
        END: 35,
        ENTER: 13,
        SPACE: 32,
        DELETE: 46,
        TAB: 9
    },

    generateID: function (base) {
        return base + Math.floor(Math.random() * 999);
    },

    getDirectChildren: function (elm, selector) {
        return Array.prototype.filter.call(elm.children, function (child) {
            return child.matches(selector);
        });
    },

    getUrlHash: function () {
        return window.location.hash.replace('#', '');
    },

    /**
     * Use history.replaceState so clicking through Tabs
     * does not create dozens of new history entries.
     * Browser back should navigate to the previous page
     * regardless of how many Tabs were activated.
     *
     * @param {string} hash
     */
    setUrlHash: function (hash) {
        if (history.replaceState) {
            history.replaceState(null, '', '#' + hash);
        } else {
            location.hash = hash;
        }
    }
};

(function (w, doc, undefined) {
    /**
     * ARIA Tabbed Interface
     * Creates a tab list to toggle the visibility of
     * different subsections of a document.
     *
     * Author: Scott O'Hara
     * Version: 2.1.3
     * License: https://github.com/scottaohara/a11y_tab_widget/blob/master/LICENSE
     */
    var ARIAtabsOptions = {
        baseID: 'atab_',
        defaultTabLabel: 'Tab ',
        elClass: 'atabs',
        customTabClassAttribute: 'data-atabs-tab-class',
        tabLabelAttribute: 'data-atabs-tab-label',
        headingAttribute: 'data-atabs-heading',
        defaultOrientation: 'horizontal',
        orientationAttribute: 'data-atabs-orientation',
        panelWrapper: 'data-atabs-panel-wrap',
        panelClass: 'atabs__panel',
        panelSelector: '[data-atabs-panel]',
        tabClass: 'atabs__list__tab',
        tabListClass: 'atabs__list',
        tablistSelector: '[data-atabs-list]',
        manualAttribute: 'data-atabs-manual',
        manual: false
    };


    var ARIAtabs = function (inst, options) {
        var _options = Object.assign(ARIAtabsOptions, options);
        var orientation = _options.defaultOrientation;
        var _tabListContainer;
        var _tabs = [];
        var activeIndex = 0;
        var defaultPanel = 0;
        var selectedTab = activeIndex;
        var el = inst;
        var hasPanelWrapper = el.querySelector('[' + _options.panelWrapper + ']');
        var elID;
        var headingSelector = '[' + _options.headingAttribute + ']';

        var init = function () {
            elID = el.id || util.generateID(_options.baseID);

            if (el.getAttribute(_options.orientationAttribute) === 'vertical') {
                orientation = 'vertical';
            }

            if (el.hasAttribute(_options.manualAttribute)) {
                _options.manual = true;
            }

            el.classList.add(_options.elClass);

            // find or create the tabList
            _tabListContainer = generateTablistContainer();

            // create the tabs and setup the panels
            buildTabs.call(this);

            // If there's a table of contents for no-js sections,
            // that won't be needed anymore. Remove it.
            deleteTOC();

            if (activeIndex > -1) {
                activateTab();
            }
        }; // init()


        var generateTablistContainer = function () {
            var tabListContainer = el.querySelector(_options.tablistSelector) || doc.createElement('div');
            tabListContainer.setAttribute('role', 'tablist');
            tabListContainer.classList.add(_options.tabListClass);
            tabListContainer.id = elID + '_list';
            tabListContainer.innerHTML = ''; // clear out anything that shouldn't be there
            if (orientation === 'vertical') {
                tabListContainer.setAttribute('aria-orientation', orientation);
            }
            el.insertBefore(tabListContainer, el.querySelector(':first-child'));

            return tabListContainer;
        }; // generateTablistContainer()


        this.addTab = function (panel, label, customClass) {
            var customClass = customClass || panel.getAttribute(_options.customTabClassAttribute);

            var generateTab = function (index, id, tabPanel, customClass) {
                var newTab = doc.createElement('span');
                newTab.id = elID + '_tab_' + index;
                newTab.tabIndex = -1;
                newTab.setAttribute('role', 'tab');
                newTab.setAttribute('aria-selected', activeIndex === index);
                if (activeIndex === index) {
                    newTab.setAttribute('aria-controls', id);
                }
                newTab.setAttribute('data-controls', id);
                newTab.innerHTML = tabPanel;
                newTab.classList.add(_options.tabClass);
                if (customClass) {
                    newTab.classList.add(customClass);
                }

                newTab.addEventListener('click', function () {
                    onClick.call(this, index);
                    this.focus();
                    updateUrlHash();
                }, false);

                newTab.addEventListener('keydown', tabElementPress.bind(this), false);
                newTab.addEventListener('focus', function () {
                    checkYoSelf.call(this, index);
                }, false);

                return newTab;
            };

            var newPanel = panel;
            var i = _tabs.length;

            if (!newPanel) {
                return;
            }

            var panelHeading = newPanel.querySelector(headingSelector);
            var finalLabel = [
                label,
                newPanel.getAttribute(_options.tabLabelAttribute),
                panelHeading && panelHeading.textContent,
                _options.defaultTabLabel + (i + 1)
            ]
                .filter(function (l) {
                    return l && l !== '';
                })[0];

            var newId = newPanel.id || elID + '_panel_' + i;
            var t = generateTab(i, newId, finalLabel, customClass);

            _tabListContainer.appendChild(t);
            newPanel.id = newId;
            newPanel.setAttribute('role', 'tabpanel');
            newPanel.setAttribute('aria-labelledby', elID + '_tab_' + i);
            newPanel.classList.add(_options.panelClass);
            newPanel.hidden = true;

            if (!el.contains(panel)) {
                el.appendChild(panel);
            }

            if (newPanel.getAttribute('id') === util.getUrlHash()) {
                activeIndex = i;
            } else if (defaultPanel === 0 && newPanel.getAttribute('data-atabs-panel') === 'default') {
                activeIndex = i;
                defaultPanel = activeIndex;
            }

            if (panelHeading) {
                if (panelHeading.getAttribute(_options.headingAttribute) !== 'keep') {
                    panelHeading.parentNode.removeChild(panelHeading);
                }
            }

            newPanel.addEventListener('keydown', panelElementPress.bind(this), false);
            newPanel.addEventListener('blur', removePanelTabindex, false);

            _tabs.push({
                tab: t,
                panel: newPanel
            });
        }; // this.addTab


        var buildTabs = function () {
            var tabs;

            /**
             * Typically tab panels should be direct children of the main tab widget
             * wrapper.  This is necessary so that the script can appropriately associate
             * each tablist with the appropriate tabpanels, allowing for nested tab widgets.
             *
             * If a wrapper for the tabpanels is necessary, for styling/other reasons, then
             * this if statement will look to see if the appropriate panel wrapper div is in
             * place, and if so, adjust the element used to look for the direct children.
             */
            if (hasPanelWrapper) {
                tabs = util.getDirectChildren(hasPanelWrapper, _options.panelSelector);
            }
            else {
                tabs = util.getDirectChildren(el, _options.panelSelector);
            }


            for (var i = 0; i < tabs.length; i++) {
                this.addTab(tabs[i]);
            }
        }; // buildTabs()


        var deleteTOC = function () {
            if (el.getAttribute('data-atabs-toc')) {
                var toc = doc.getElementById(el.getAttribute('data-atabs-toc'));
                // safety check to make sure a TOC isn't set to be deleted
                // after it's already deleted. e.g. if there are two
                // dat-atabs-toc that equal the same ID.
                if (toc) {
                    toc.parentNode.removeChild(toc);
                }
            }
        }; // deleteTOC()


        var incrementActiveIndex = function () {
            if (activeIndex < _tabs.length - 1) {
                return ++activeIndex;
            }
            else {
                activeIndex = 0;
                return activeIndex;
            }
        }; // incrementActiveIndex()


        var decrementActiveIndex = function () {
            if (activeIndex > 0) {
                return --activeIndex;
            }
            else {
                activeIndex = _tabs.length - 1;
                return activeIndex;
            }
        }; // decrementActiveIndex()


        var focusActiveTab = function () {
            _tabs[activeIndex].tab.focus();
        }; // focusActiveTab()


        var onClick = function (index) {
            activeIndex = index;
            activateTab();
        }; // onClick()


        var moveBack = function (e) {
            e.preventDefault();
            decrementActiveIndex();
            focusActiveTab();

            if (!_options.manual) {
                activateTab();
                updateUrlHash();
            }
        }; // moveBack()


        var moveNext = function (e) {
            e.preventDefault();
            incrementActiveIndex();
            focusActiveTab();

            if (!_options.manual) {
                activateTab();
                updateUrlHash();
            }
        }; // moveNext()


        /**
         * A tabpanel is focusable upon hitting the TAB key
         * from a tab within a tablist.  When navigating away
         * from the tabpanel, with the TAB key, remove the
         * tabindex from the tabpanel.
         */
        var panelElementPress = function (e) {
            var keyCode = e.keyCode || e.which;

            switch (keyCode) {
                case util.keyCodes.TAB:
                    removePanelTabindex();
                    break;

                default:
                    break;
            }
        }; // panelElementPress()


        var removePanelTabindex = function () {
            _tabs[activeIndex].panel.removeAttribute('tabindex');
        }; // removePanelTabindex()


        var tabElementPress = function (e) {
            var keyCode = e.keyCode || e.which;

            switch (keyCode) {
                case util.keyCodes.TAB:
                    _tabs[selectedTab].panel.tabIndex = 0;
                    activeIndex = selectedTab;
                    break;

                case util.keyCodes.ENTER:
                case util.keyCodes.SPACE:
                    e.preventDefault();
                    activateTab();
                    updateUrlHash();
                    break;

                case util.keyCodes.LEFT:
                case util.keyCodes.UP:
                    moveBack(e);
                    break;

                case util.keyCodes.RIGHT:
                case util.keyCodes.DOWN:
                    moveNext(e);
                    break;

                case util.keyCodes.END:
                    e.preventDefault();
                    activeIndex = _tabs.length - 1;
                    focusActiveTab();
                    if (!_options.manual) {
                        activateTab();
                        updateUrlHash();
                    }
                    break;

                case util.keyCodes.HOME:
                    e.preventDefault();
                    activeIndex = 0;
                    focusActiveTab();
                    if (!_options.manual) {
                        activateTab();
                        updateUrlHash();
                    }
                    break;

                case util.keyCodes.DELETE:
                    if (_tabs.length > 1 && canRemove) {
                        e.preventDefault();
                        removeTabAndPanel(activeIndex);
                        focusActiveTab();
                    }
                    break;

                default:
                    break;
            }
        }; // tabElementPress()


        /**
         * This function shouldn't exist.  BUT for...
         * https://github.com/nvaccess/nvda/issues/8906
         * https://github.com/FreedomScientific/VFO-standards-support/issues/132
         *
         * Note this doesn't completely fix JAWS announcements.
         * With this function, focus will be placed on the correct Tab,
         * but JAWS will make no announcement until the user begins
         * re-navigating with arrow keys.
         *
         * The alternative is not using this, having JAWS announce the
         * inactive tag (which will receive focus), JAWS will announce
         * to use the Space key to activate, but nothing will happen.
         */
        var checkYoSelf = function (index) {
            if (index !== activeIndex) {
                focusActiveTab();
            }
        }; // checkYoSelf()


        var deactivateTabs = function () {
            for (var i = 0; i < _tabs.length; i++) {
                deactivateTab(i);
            }
        }; // deactivateTabs()


        var deactivateTab = function (idx) {
            _tabs[idx].panel.hidden = true;
            _tabs[idx].tab.tabIndex = -1;
            _tabs[idx].tab.setAttribute('aria-selected', false);
            _tabs[idx].tab.removeAttribute('aria-controls');
            // remove the aria-controls from inactive tabs since
            // a user can *not* move to their associated element
            // if that element is not displayed.
        }; // deactivateTab()


        /**
         * Update the active Tab and make it focusable.
         * Deactivate any previously active Tab.
         * Reveal active Panel.
         */
        var activateTab = function () {
            var active = _tabs[activeIndex];
            deactivateTabs();
            active.tab.setAttribute('aria-controls', active.tab.getAttribute('data-controls'))
            active.tab.setAttribute('aria-selected', true);
            active.tab.tabIndex = 0;
            active.panel.hidden = false;
            selectedTab = activeIndex;
            return selectedTab;
        }; // activateTab()


        /**
         * Update URL Hash so direct link to the currently open Tab is exposed for copy & paste.
         */
        var updateUrlHash = function () {
            var active = _tabs[activeIndex];
            util.setUrlHash(active.tab.getAttribute('data-controls'));
        }; // updateUrlHash()


        init.call(this);
        return this;
    }; // ARIAtabs()


    w.ARIAtabs = ARIAtabs;
})(window, document);

theme.stickyNavigation = (function () {
    // Feature detection
    function featureCheck() {
        if (typeof IntersectionObserver == "undefined") return false;
        try {
            addStickyClass();
        } catch (e) {
            return false;
        }

        return true;
    }

    // Only run if IntersectionObserver is available on browser
    if (featureCheck()) {
        addStickyClass();
    }

    function addStickyClass() {
        // Approach inspired by https://developers.google.com/web/updates/2017/09/sticky-headers
        var observer = new IntersectionObserver(
            function (entries) {
                if (entries[0].intersectionRatio === 0)
                    $(".header-section").addClass("header-section--sticky");
                else if (entries[0].intersectionRatio === 1)
                    $(".header-section").removeClass("header-section--sticky");
            },
            { threshold: [0, 1] }
        );

        observer.observe(document.querySelector(".announcement-bar-section"));
    }
})();
// made modifications for the Scent Swatches in KM-294, the slide show didn't reinitialize after changing the variant color. 

function productScripts() {
    let startingSlide = 0;

    if (window.theme.activeVariantImage !== window.theme.defaultVariantImage) {
        const targetThumb = document.querySelector('.product-single__thumbnail[data-image-id="' + window.theme.activeVariantImage + '"]');
        if (targetThumb && targetThumb.parentElement) {
            const siblings = Array.from(targetThumb.parentElement.children);
            const index = siblings.indexOf(targetThumb);
            startingSlide = index;
        } else {
        }
    }

    let product_single_slideshow = $(".product-single__slideshow");
    product_single_slideshow.on('afterChange', function () {
        let active = product_single_slideshow.find('.slick-list .slick-active');
        if (active.hasClass('product-single__video-wrapper')) {
            let video = active.find('video')[0];
            if (video.classList.contains('no-source')) {
                const videoContainer = active.find('.product-single__video');
                const sources = videoContainer.data('sources').split(',');
                sources.forEach(item => {
                    let parts = item.split('|');
                    const source = document.createElement('source');
                    source.setAttribute('src', parts[0]);
                    source.setAttribute('type', parts[1]);
                    video.appendChild(source);
                });
                videoContainer.prepend(video);
                video.classList.remove('no-source');
            }
            video.play();
            $('.product-slick__video-dot .play__video').hide();
            $('.product-slick__video-dot .pause__video').show();
        } else {
            $('.product-slick__video-dot .play__video').show();
            $('.product-slick__video-dot .pause__video').hide();
        }
    });

    product_single_slideshow.on('init', function () {
        if (product_single_slideshow.hasClass('video-available')) {
            let video_position = parseInt(product_single_slideshow.data('video-position'));
            let video_button_html = `<button type="button" aria-label="Pause Video">
      <svg class="play__video" aria-hidden="false" width="14px" height="14px" viewBox="0 0 16 16" transform="rotate(0)" class="Icon-sc-1ny8wc9-0 eMKOdI"><path d="M4 13.15V2.946c0-.403.452-.636.783-.408l8.156 5.608a.5.5 0 01-.038.847l-8.156 4.588A.498.498 0 014 13.15z"></path></svg>
      <svg class="pause__video" aria-hidden="false" width="14px" height="14px" viewBox="0 0 16 16" transform="rotate(0)" class="Icon-sc-1ny8wc9-0 eMKOdI"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a1 1 0 00-1 1v8a1 1 0 102 0V4a1 1 0 00-1-1zm6 0a1 1 0 00-1 1v8a1 1 0 102 0V4a1 1 0 00-1-1z"></path></svg>
    </button>`;

            if (video_position !== NaN && video_position > 0) {
                product_single_slideshow.find('.slick-dots li').eq(video_position - 1).addClass('product-slick__video-dot').prepend(video_button_html);
            } else {
                product_single_slideshow.find('.slick-dots li:last-child').addClass('product-slick__video-dot').prepend(video_button_html);
            }
        }
    });

    product_single_slideshow.slick({
        asNavFor: '.product-single__thumbnails',
        arrows: false,
        initialSlide: startingSlide,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    dots: true,
                    asNavFor: null
                }
            }
        ]
    });

    let timeOutFunctionId;

    function workAfterResizeIsDone() {
        $(".product-single__thumbnails").slick('unslick');
        thumbnailSliderInit();
        defineHeaderHeight();
    }

    window.addEventListener("resize", function () {
        clearTimeout(timeOutFunctionId); // Clear the previous timeout
        timeOutFunctionId = setTimeout(workAfterResizeIsDone, 500); // Set a new timeout
    });

    function calcVisibleThumbs() {
        const availableHeight = product_single_slideshow.outerHeight();
        const thumbHeight = $('.product-single__thumbnail').first().outerHeight();
        return Math.floor(availableHeight / thumbHeight) - 2;
    }

    function defineHeaderHeight() {
        if (window.innerWidth < 768) {
            return;
        }
        const header = $('.site-header');
        const stickyMediaContainer = $('.product-single__media-container');
        stickyMediaContainer.removeAttr('style');
        stickyMediaContainer.attr('style', '--header-height: ' + header.outerHeight() + 'px');
    }

    function thumbnailSliderInit() {
        if (window.innerWidth < 768) {
            return;
        }
        $(".product-single__thumbnails").slick({
            asNavFor: '.product-single__slideshow',
            vertical: true,
            verticalSwiping: true,
            slidesToShow: calcVisibleThumbs(),
            slidesToScroll: 1,
            focusOnSelect: true,
            initialSlide: startingSlide,
        });
    }

    defineHeaderHeight();
    thumbnailSliderInit();

    $('.product-single__video-handle').on('click', function () {
        let $this = $(this);
        let video = $this.siblings('video')[0];
        if ($this.attr('aria-label') == 'Pause Video') {
            $this.attr('aria-label', 'Play Video');
            $this.find('.pause__video').hide();
            $this.find('.play__video').show();
            video.pause();
        } else {
            $this.attr('aria-label', 'Pause Video');
            $this.find('.pause__video').show();
            $this.find('.play__video').hide();
            video.play();
        }
    });

    $(document).on('click', '.product-slick__video-dot.slick-active .play__video', function () {
        let parent = $(this).closest(".product-single__slideshow");
        let video = parent.find(".product-single__video-wrapper.slick-active video")[0];
        $(this).hide();
        $(this).siblings(".pause__video").show();
        video.play();
    });

    $(document).on('click', '.product-slick__video-dot.slick-active .pause__video', function () {
        let parent = $(this).closest(".product-single__slideshow");
        let video = parent.find(".product-single__video-wrapper.slick-active video")[0];
        $(this).hide();
        $(this).siblings(".play__video").show();
        video.pause();
    });

    $(document).on('keydown', function (event) {
        if (event.key === "ArrowLeft") {
            product_single_slideshow.slick('slickPrev')
        } else if (event.key === "ArrowRight") {
            product_single_slideshow.slick('slickNext')
        }
    })
}
theme.slideshow = (function () {
    productScripts();
})();

theme.ingredientsSlides = (function () {
    var ingredients = $('.ingredients__items');
    if (ingredients.length > 0) {
        ingredients.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        arrows: false
                    }
                }
            ]
        })
    }
})();


window.theme = window.theme || {};

theme.CartGift = (function () {
    var selectors = {
        cartWrapper: "[data-cart-wrapper]",
        enable: "#enable_gift",
        content: "[data-cart-gift-content]",
        enableGiftWrap: "#enable_gift-wrap",
        cartNoteInput: ".cart-note__input",
        userMessage: ".cart-gift__user-message",
        characterCountText: ".cart-gift__characters-value",
        cartLineItemContainer: "[data-cart-line-items]",
        tableTarget: "[data-table-target]",
        tableContent: "[data-table-content]",
        footerTarget: "[data-footer-target]",
        footerContent: "[data-footer-content]",
        cartRemove: "[data-cart-remove]"
    };

    var classes = {
        characterCountActive: "cart-gift__user-message--display",
        maxCharacterCountReached: "cart-gift__user-message--max-reached"
    };

    function CartGift(container) {
        this.$container = this.$container = $(container);
        this.$enable = $(selectors.enable, this.$container);
        this.$content = $(selectors.content, this.$container);
        this.$enableGiftWrap = $(selectors.enableGiftWrap, this.$container);
        this.$cartNoteInput = $(selectors.cartNoteInput, this.$container);
        this.$userMessage = $(selectors.userMessage, this.$container);
        this.$characterCountText = $(selectors.characterCountText, this.$container);

        this.$enable.on("change", this._onEnableChange.bind(this));
        this.$enableGiftWrap.on("change", this._onGiftWrapChange.bind(this));

        // Event listener on cart wrapper to retain event listener after line item updates
        $(selectors.cartWrapper).on(
            "click",
            selectors.cartRemove,
            function (event) {
                this._onGiftWrapRemove(event);
            }.bind(this)
        );

        // Capture native keyup event on field input
        this.$cartNoteInput.on(
            "keyup",
            function (event) {
                this._onFieldInput(event);
            }.bind(this)
        );
    }

    CartGift.prototype = _.assignIn({}, CartGift.prototype, {
        _onEnableChange: function () {
            if (this.$enable.is(":checked")) {
                this.$content.removeAttr("aria-hidden");
            } else {
                this.$content.attr("aria-hidden", true);

                // If unchecked, uncheck Gift Wrap option too and trigger removal of Gift Wrap product from cart
                if (this.$enableGiftWrap.is(":checked")) {
                    this.$enableGiftWrap.prop("checked", false).change();
                }
            }
        },

        _onGiftWrapChange: function () {
            var updates = {};

            updates[this.$enableGiftWrap.data("gift-wrap")] = this.$enableGiftWrap.is(
                ":checked"
            )
                ? 1
                : 0;

            var params = {
                url: "/cart/update.js",
                data: { updates: updates },
                dataType: "json"
            };

            $.post(params).done(
                function () {
                    this._updateCart();
                }.bind(this)
            );
        },

        _onGiftWrapRemove: function (event) {
            if ($(event.target).data("product-title") === "Gift Wrap") {
                $(selectors.enableGiftWrap).prop("checked", false);
            }
        },

        _updateCart: function () {
            $.get(
                "/cart",
                {},
                function (data) {
                    var $response = $("<div />").html(data);

                    var $tableContent = $response.find(selectors.tableContent);
                    var $footerContent = $response.find(selectors.footerContent);

                    $(selectors.tableTarget).html($tableContent);
                    $(selectors.footerTarget).html($footerContent);
                },
                "html"
            );
        },

        _onFieldInput: function () {
            var maxCharacters = parseInt(this.$cartNoteInput.attr("maxlength"));

            this.$userMessage.addClass(classes.characterCountActive);
            this.$characterCountText.text(
                maxCharacters - $(event.target).val().length
            );

            if (this.$characterCountText.text() === "0") {
                this.$userMessage.addClass(classes.maxCharacterCountReached);
            } else {
                this.$userMessage.removeClass(classes.maxCharacterCountReached);
            }
        }
    });

    return CartGift;
})();

window.theme = window.theme || {};

theme.ProductToggle = (function () {
    var selectors = {
        productToggle: ".product-toggles__radio",
        productForm: ".product-single__switchable-form",
        productSection: "#ProductSection-",
        variantInput: ".product-form__radio-group input",
        productFormMiniSubscription: "[data-product-mini-subscription]"
    };

    function ProductToggle(container) {
        // Capture native event
        $(selectors.productToggle).change(
            function (event) {
                const productToggle = event.target;
                const sellingPlanGroup = productToggle.closest('.selling_plan_group');
                if (sellingPlanGroup) return;
                this._onProductToggleChange(event);
            }.bind(this)
        );

        // Capture native event
        $(selectors.variantInput).change(
            function (event) {
                this._onVariantChange(event);
            }.bind(this)
        );

        // If URL contains "mini", pre-select "mini" form
        this._getMiniProductForm();
    }

    ProductToggle.prototype = _.assignIn({}, ProductToggle.prototype, {
        _onProductToggleChange: function (event) {
            if ($(event.target).is(":checked")) {
                var targetValue = $(event.target).attr("data-value");
                var targetFormId = $(event.target).attr("data-target-id");
                var formExists = this._checkFormExists(targetFormId);

                if (formExists) {
                    this._hideAllForms();
                    this._displayForm(targetFormId);
                    this._checkSelectedOptions(targetFormId, targetValue);
                    this._updateHiddenFormOptions(event, targetValue);
                } else {
                    this._disableUnavailableOptions(event);
                }
            }
        },

        _checkFormExists: function (formId) {
            return $(selectors.productSection + formId).length > 0 ? true : false;
        },

        _hideAllForms: function () {
            $(selectors.productForm).hide();
        },

        _displayForm: function (formId) {
            $(selectors.productSection + formId).show();
        },

        _checkSelectedOptions: function (formId, value) {
            $(selectors.productSection + formId)
                .find($("[data-value=" + value + "]"))
                .prop("checked", true)
                .focus();
        },

        _updateHiddenFormOptions: function (event, value) {
            $(selectors.productToggle + '[data-value="' + value + '"]').prop(
                "checked",
                true
            );
        },

        _disableUnavailableOptions: function (event) {
            if (event.originalEvent) {
                $(event.target)
                    .prop("disabled", true)
                    .prop("checked", false);

                $(event.target)
                    .siblings(selectors.productToggle)
                    .prop("checked", true)
                    .click()
                    .change();
            }
        },

        _onVariantChange: function (event) {
            if (event.originalEvent) {
                $(selectors.variantInput + '[value="' + $(event.target).val() + '"]')
                    .prop("checked", true)
                    .click()
                    .change();
            }
        },

        _getMiniProductForm: function () {
            var pageHandle = window.location.pathname.split("/").reverse()[0];

            if (pageHandle.indexOf("mini") > 0) {
                $(selectors.productToggle + "[data-value='mini']")
                    .prop("checked", true)
                    .change();

                if ($(selectors.productFormMiniSubscription).length) {
                    $(selectors.productToggle + "[data-value='one-time']")
                        .prop("checked", true)
                        .change();
                }
            }
        }
    });

    return ProductToggle;
})();

theme.ProductCard = (function () {
    function ProductCard(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");

        this.selectors = {
            addToCart: "[data-add-to-cart]",
            addToCartText: "[data-add-to-cart-text]",
            cartCount: "[data-cart-count]",
            cartCountBubble: "[data-cart-count-bubble]",
            cartPopup: "[data-cart-popup]",
            cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
            cartPopupClose: "[data-cart-drawer-close]",
            cartPopupOpen: "[data-cart-drawer-open]",
            cartPopupOpenMobile: "[data-cart-drawer-open-mobile]",
            cartPopupDismiss: "[data-cart-drawer-dismiss]",
            cartPopupImage: "[data-cart-popup-image]",
            cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
            cartPopupImagePlaceholder: "[data-cart-popup-image-placeholder]",
            cartPopupItemWrapper: ".cart-drawer",
            cartPopupItemQuantity: ".cart-popup__qty-input",
            cartPopupIncreaseQuantity: "[data-cart-popup-increase-qty]",
            cartPopupDecreaseQuantity: "[data-cart-popup-decrease-qty]",
            cartPopupPlaceholderSize: "[data-placeholder-size]",
            cartPopupProductDetails: "[data-cart-popup-product-details]",
            cartPopupQuantity: "[data-cart-popup-quantity]",
            cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
            cartPopupShippingProgressBar: "[data-progress-bar]",
            cartPopupShippingProgressText: "[data-free-shipping-text]",
            cartPopupSubtotal: "[data-cart-drawer-subtotal]",
            cartPopupTitle: "[data-cart-popup-title]",
            cartPopupWrapper: "[data-cart-popup-wrapper]",
            loader: "[data-loader]",
            loaderStatus: "[data-loader-status]",
            quantity: "[data-quantity-input]",
            SKU: ".variant-sku",
            productStatus: "[data-product-status]",
            originalSelectorId: "#ProductSelect-" + sectionId,
            productForm: "[data-product-form]",
            errorMessage: "[data-error-message]",
            errorMessageWrapper: "[data-error-message-wrapper]",
            variantPicker: ".product-card-form__input select",
            primaryImage: ".grid-view-item__image--primary"
        };

        this.classes = {
            cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
            hidden: "hide",
            inputError: "input--error",
            cartImage: "cart-popup-item__image",
            productFormErrorMessageWrapperHidden:
                "product-form__error-message-wrapper--hidden"
        };

        this.$quantityInput = $(this.selectors.quantity, $container);
        this.$errorMessageWrapper = $(
            this.selectors.errorMessageWrapper,
            $container
        );
        this.$addToCart = $(this.selectors.addToCart, $container);
        this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
        this.$shopifyPaymentButton = $(
            this.selectors.shopifyPaymentButton,
            $container
        );

        this.$loader = $(this.selectors.loader, this.$addToCart);
        this.$loaderStatus = $(this.selectors.loaderStatus, $container);

        this._stringOverrides();
        this._initAddToCart();
    }

    ProductCard.prototype = _.assignIn({}, ProductCard.prototype, {
        _stringOverrides: function () {
            theme.productStrings = theme.productStrings || {};
            $.extend(theme.strings, theme.productStrings);
        },

        _initAddToCart: function () {

            // this.selectors.productForm, this.$container
            $(this.selectors.productForm, this.$container).on(
                "submit",
                function (evt) {
                    if (this.$addToCart.is("[aria-disabled]")) {
                        evt.preventDefault();
                        return;
                    }

                    evt.preventDefault();

                    // this.$previouslyFocusedElement = $(":focus");

                    var isInvalidQuantity = this.$quantityInput.val() <= 0;

                    if (isInvalidQuantity) {
                        this._showErrorMessage(theme.strings.quantityMinimumMessage);
                        return;
                    }

                    if (!isInvalidQuantity) {
                        // disable the addToCart and dynamic checkout button while
                        // request/cart popup is loading and handle loading state
                        this._handleButtonLoadingState(true);
                        var $data = $(this.selectors.productForm, this.$container);
                        this._addItemToCart(evt, $data);
                        return;
                    }
                }.bind(this)
            );
            $(this.selectors.variantPicker, this.$container).on(
                "change",
                this._handleVariantChange.bind(this)
            );
        },

        _handleVariantChange: function (event) {
            const activeVariant = window.variantImages.find(variant => variant.id.toString() === event.target.value);
            if (!activeVariant) {
                return;
            }
            const primaryImage = this.$container.find(this.selectors.primaryImage);
            primaryImage.attr('srcset', activeVariant.sizes.join(', '));
            primaryImage.attr('src', activeVariant.src);
        },

        _addItemToCart: function (event, data) {
            const formData = $(data).serialize();
            const productId = $(data).data('productid');
            var now = new Date().getTime();
            let sku = $(data).find('[name="sku"]').val().trim();
            let addon = {}

            if (window.enable_sex_stone_free_gift) {
                if (sku.startsWith('SEX-')) {
                    formData += '&properties[_id]=' + now;
                    addon = {
                        url: "/cart/add.js",
                        data: "form_type=product&id=" + window.sex_stone_free_gift + "&quantity=1&properties[_id]=" + now,
                        type: 'post',
                        dataType: "json"
                    };
                }
            }

            const formParams = new URLSearchParams(formData);
            const tempObject = Object.fromEntries(formParams);
            let formDataJSON = {};
            // Shopify AJAX Cart API only cares for these parameters.
            const accepted_keys = ['id', 'quantity', 'properties', 'selling_plan']
            for (let key in tempObject) {
                // check if key starts with one of the accepted keys and the value is not empty
                if (accepted_keys.some(accepted_key => key.startsWith(accepted_key)) && tempObject[key] !== "") {
                    if (key.startsWith('properties')) {
                        if (!formDataJSON['properties']) {
                            formDataJSON['properties'] = {};
                        }
                        let innerKey = key.split('[')[1].split(']')[0];
                        // check if value is not empty
                        if (tempObject[key] !== "") {
                            formDataJSON['properties'][innerKey] = tempObject[key];
                        }
                    } else {
                        if (tempObject[key] !== "") {
                            formDataJSON[key] = tempObject[key];
                        }
                    }
                }
            }

            // if the object strangely has no quantity, make sure we set that and default to 1.
            if (!formDataJSON.hasOwnProperty('quantity')) {
                formDataJSON.quantity = 1;
            }

            // console.log("ProductCard _addItemToCart data", $(data));
            // console.log("ProductCard _addItemToCart formData", formData);
            // console.log("ProductCard _addItemToCart formDataJSON", JSON.stringify(formDataJSON));
            const items_added = [formDataJSON];

            var params = {
                url: "/cart/add.js",
                data: { items: items_added },
                dataType: "json"
            };

            if (Object.keys(addon).length > 0) {
                $.ajaxq('ProductQueue', addon)
                    .done(
                        function (item) {
                            $.post(params)
                                .done(
                                    function (res) {
                                        document.dispatchEvent(new CustomEvent("cart:item:added", {
                                            detail:
                                            {
                                                'response': res,
                                                'items_added': items_added
                                            }
                                        }));
                                        location.href = '/cart';
                                    }.bind(this)
                                )
                                .fail(
                                    function (response) {
                                        // this.$previouslyFocusedElement.focus();
                                        var errorMessage = response.responseJSON
                                            ? response.responseJSON.description
                                            : theme.strings.cartError;
                                        this._showErrorMessage(errorMessage);
                                        this._handleButtonLoadingState(false);
                                    }.bind(this)
                                );
                        }
                    )
                    .fail(
                        function (response) {
                            alert('Something went wrong. Please try again after some time.');
                        });
            } else {
                let _this = this;

                $.post(params)
                    .done(
                        function (res) {
                            document.dispatchEvent(new CustomEvent("cart:item:added", {
                                detail:
                                {
                                    'response': res,
                                    'items_added': items_added
                                }
                            }));

                            const params = {
                                url: "/cart/update.js",
                                updates: {
                                    _id: 1
                                },
                                dataType: "json"
                            };

                            $.post(params).done(
                                function (newCart) {
                                    window.theme.CartDrawer.refresh().then(() => {
                                        window.theme.CartDrawer.handleGWP();
                                        window.theme.CartDrawer.open();
                                        this._handleButtonLoadingState(false);
                                    });
                                }.bind(this)
                            );
                        }.bind(this)
                    )
                    .fail(
                        function (response) {
                            // this.$previouslyFocusedElement.focus();
                            var errorMessage = response.responseJSON
                                ? response.responseJSON.description
                                : theme.strings.cartError;
                            this._showErrorMessage(errorMessage);
                            this._handleButtonLoadingState(false);
                        }.bind(this)
                    );
            }
        },

        _handleButtonLoadingState: function (isLoading) {
            const $addToCart = $(this.$addToCart, this.$container);
            const $addToCartText = $(this.$addToCartText, this.$container);
            const $loader = $(this.$loader, this.$container);
            const $loaderStatus = $(this.$loaderStatus, this.$container);
            const $shopifyPaymentButton = $(this.$shopifyPaymentButton, this.$container);
            if (isLoading) {
                $addToCart.attr("aria-disabled", true);
                $addToCartText.addClass(this.classes.hidden);
                $loader.removeClass(this.classes.hidden);
                $shopifyPaymentButton.attr("disabled", true);
                $loaderStatus.attr("aria-hidden", false);
            } else {
                $addToCart.removeAttr("aria-disabled");
                $addToCartText.removeClass(this.classes.hidden);
                $loader.addClass(this.classes.hidden);
                $shopifyPaymentButton.removeAttr("disabled");
                $loaderStatus.attr("aria-hidden", true);
            }
        },

        _showErrorMessage: function (errorMessage) {
            $(this.selectors.errorMessage, this.$container).html(errorMessage);

            if (this.$quantityInput.length !== 0) {
                this.$quantityInput.addClass(this.classes.inputError);
            }

            this.$errorMessageWrapper
                .removeClass(this.classes.productFormErrorMessageWrapperHidden)
                .attr("aria-hidden", true)
                .removeAttr("aria-hidden");
        },

        _hideErrorMessage: function () {
            this.$errorMessageWrapper.addClass(
                this.classes.productFormErrorMessageWrapperHidden
            );

            if (this.$quantityInput.length !== 0) {
                this.$quantityInput.removeClass(this.classes.inputError);
            }
        },
        _setupCartPopup: function (item) {
            this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
            this.$cartPopupWrapper =
                this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
            this.$cartPopupTitle =
                this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
            this.$cartPopupQuantity =
                this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
            this.$cartPopupQuantityLabel =
                this.$cartPopupQuantityLabel ||
                $(this.selectors.cartPopupQuantityLabel);
            this.$cartPopupClose =
                this.$cartPopupClose || $(this.selectors.cartPopupClose);
            this.$cartPopupOpen =
                this.$cartPopupOpen || $(this.selectors.cartPopupOpen);
            this.$cartPopupOpenMobile =
                this.$cartPopupOpenMobile || $(this.selectors.cartPopupOpenMobile);
            this.$cartPopupDismiss =
                this.cartPopupDismiss || $(this.selectors.cartPopupDismiss);
            this.$cartPopupImagePlaceholder =
                this.$cartPopupImagePlaceholder ||
                $(this.selectors.cartPopupImagePlaceholder);
            this.$cartPopupItemWrapper =
                this.$cartPopupItemWrapper || $(this.selectors.cartPopupItemWrapper);
            this.$cartPopupItemQuantity =
                this.$cartPopupItemQuantity || $(this.selectors.cartPopupItemQuantity);

            $('[data-cart-drawer-footer]').removeClass('hide');
            this._updateCartPopupContent(item);
            this._setupCartPopupEventListeners();
        },

        _updateCartPopupContent: function (item) {
            // if(item.quantity == 1){
            this._setupCartPopupItem(item);
            $('[data-empty-cart-drawer-container]').empty();
            $('.rebuy-container').removeClass('hide');
            // }
            // //otherwise just update the cart item's quantity
            // else{
            //   this.$cartPopupWrapper.find("[data-variant-id='" + item.variant_id + "']").val(item.quantity);
            //   // this.$cartPopupWrapper.find(`[data-variant-id=${item.variant_id}]`).val(item.quantity);
            // }
        },

        _setupCartPopupEventListeners: function () {
            this.$cartPopupWrapper.on(
                "keyup",
                function (event) {
                    if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
                        this._hideCartPopup(event);
                    }
                }.bind(this)
            );

            this.$cartPopupClose.on("click", this._hideCartPopup.bind(this));
            this.$cartPopupDismiss.on("click", this._hideCartPopup.bind(this));

            $("body").on("click", this._onBodyClick.bind(this));
        },

        _setupCartPopupItem: function (item) {
            //generate html for newly added item
            var newItemWrapper = document.createElement('div');
            $(newItemWrapper).addClass('cart-popup__item-wrapper');
            $(newItemWrapper).attr('data-variant-id', item.variant_id);

            const newItemImageWrapper = '<div class="cart-popup__image-wrapper"><img class="cart-popup__image" src=' + item.featured_image.url + 'alt=' + item.featured_image.alt + 'data-cart-item-image></div>';
            const itemPrice = theme.Currency.formatMoney(
                item.original_price * item.quantity,
                theme.moneyFormat
            );
            const itemFinaPrice = theme.Currency.formatMoney(
                item.final_price * item.quantity,
                theme.moneyFormat
            );

            const hasDiscount = item.original_price != item.final_price
            const htmlPriceElements = hasDiscount
                ? `<div data-cart-item-discounted-price-group>
          <s data-cart-item-original-price><span class="hulkapps-cart-item-price" data-key="${item.key}">${itemPrice}</span></s>
          <span class="order-discount" data-cart-item-final-price>${itemFinaPrice}</span>
        </div>`
                : `<span class='hulkapps-cart-item-price' data-key='${item.key}'>${itemPrice}</span><br>`

            var newItemProductDetails = '<div class="cart-popup__product-details">' +
                '<a href="' + item.url + '"class="cart__product-title h6 bold" data-cart-item-title>' +
                item.product_title
                + '</a>' +
                '<ul>' +
                this._setCartPopupProductDetails(
                    item.product_has_only_default_variant,
                    item.options_with_values,
                    item.properties,
                    item
                ) +
                '</ul>' +
                '<div class="cart-popup__item-row">' +
                htmlPriceElements +
                '<div class="quantity-selectors">' +
                '<label for="updates_' +
                item.key +
                '" class="cart__qty-label" aria-label="Cart item quantity" data-quantity-input>' +
                '</label>' +
                '<a class="cart-popup__qty-buttons" aria-label="Decrease item quantity" data-cart-popup-decrease-qty data-variant-id="' +
                item.variant_id +
                '"' + ' data-line-item-key="' + item.key + '">'
                + theme.strings.cartMinusIcon +
                '</a>' +
                '<input id="updates_' + item.key +
                '" class="cart-popup__qty-input" type="number" value="' + item.quantity +
                '" min="0" pattern="[0-9]*" data-quantity-input data-variant-id="' + item.variant_id +
                '" data-quantity-item="{{ forloop.index }}" data-quantity-input>' +
                '<a class="cart-popup__qty-buttons" aria-label="Increase item quantity" data-cart-popup-increase-qty data-variant-id="' +
                item.variant_id +
                '"' + ' data-line-item-key="' + item.key + '">' + theme.strings.cartPlusIcon +
                '</a>' +
                '</div>' +
                '</div>' +
                '</div>'
            // $(newItemProductDetails).find('[data-quantity-input]').val(item.quantity);
            newItemWrapper.innerHTML = newItemWrapper.innerHTML + newItemImageWrapper + newItemProductDetails;
            this.$cartPopupItemWrapper.prepend(newItemWrapper);
        },

        _setCartPopupProductDetails: function (
            product_has_only_default_variant,
            options,
            properties,
            item
        ) {
            this.$cartPopupProductDetails =
                this.$cartPopupProductDetails ||
                $(this.selectors.cartPopupProductDetails);
            var variantPropertiesHTML = "";

            if (!product_has_only_default_variant) {
                variantPropertiesHTML =
                    variantPropertiesHTML + this._getVariantOptionList(options, item);
            }

            // Show frequency in sidecart
            if (item?.selling_plan_allocation?.selling_plan?.name) {
                variantPropertiesHTML += '<li><span class="bold" data-cart-item-property-name>Frequency:</span> <span data-cart-item-property-value>' + item.selling_plan_allocation?.selling_plan?.name.replace('Delivery e', 'E') + '</li>'
            }

            //product properties i.e. ship date
            // if (properties !== null && Object.keys(properties).length !== 0) {
            //   variantPropertiesHTML =
            //     variantPropertiesHTML + this._getPropertyList(properties);
            // }

            // if (variantPropertiesHTML.length === 0) {
            //   this.$cartPopupProductDetails.html("");
            //   this.$cartPopupProductDetails.attr("hidden", "");
            // } else {
            //   this.$cartPopupProductDetails.html(variantPropertiesHTML);
            //   this.$cartPopupProductDetails.removeAttr("hidden");
            // }
            return variantPropertiesHTML;
        },

        _getVariantOptionList: function (variantOptions) {
            var variantOptionListHTML = "";

            variantOptions.forEach(function (variantOption) {
                if (variantOption.value.includes('Default')) return;
                variantOptionListHTML =
                    variantOptionListHTML +
                    '<li><span class="bold" data-cart-item-property-name>' +
                    variantOption.name +
                    ':</span> <span data-cart-item-property-value>' +
                    variantOption.value +
                    "</li>";
            });

            return variantOptionListHTML;
        },

        _getPropertyList: function (properties) {
            var propertyListHTML = "";
            var propertiesArray = Object.entries(properties);

            propertiesArray.forEach(function (property) {
                // Line item properties prefixed with an underscore are not to be displayed
                if (property[0].charAt(0) === "_") return;

                // if the property value has a length of 0 (empty), don't display it
                if (property[1].length === 0) return;

                propertyListHTML =
                    propertyListHTML +
                    '<li class="product-details__item product-details__item--property">' +
                    '<span class="product-details__property-label">' +
                    property[0] +
                    ": </span>" +
                    property[1];
                ": " + "</li>";
            });

            return propertyListHTML;
        },

        _setCartQuantity: function (quantity) {
            this.$cartPopupCartQuantity =
                this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
            var ariaLabel;

            if (quantity === 1) {
                ariaLabel = theme.strings.oneCartCount;
            } else if (quantity > 1) {
                ariaLabel = theme.strings.otherCartCount.replace("[count]", quantity);
            }

            this.$cartPopupCartQuantity.text(quantity === 0 ? '' : quantity).attr("aria-label", ariaLabel);
        },

        _setCartSubtotal: function (subtotal) {
            this.$cartPopupSubtotal =
                this.$cartPopupSubtotal || $(this.selectors.cartPopupSubtotal);

            let formattedSubtotal = theme.Currency.formatMoney(
                subtotal,
                theme.moneyFormat
            );

            this.$cartPopupSubtotal.text(formattedSubtotal).attr("aria-label", subtotal);
        },

        _updateProgressBar: function (cart) {
            const subtotal = cart.total_price;
            const cartHasSub = !!cart.items.find(item => !!item.selling_plan_allocation);
            let shippingThreshold = $('.free-shipping-progress-bar').data('shipping-threshold');
            let amountToFreeShipping = shippingThreshold - subtotal;
            amountToFreeShipping = theme.Currency.formatMoney(
                amountToFreeShipping,
                theme.moneyFormat
            );
            if (cartHasSub || (subtotal > shippingThreshold)) {
                $('[data-free-shipping-text]').html("<p>Congratulations! You’ve earned Free Shipping</p>");
                $('.shipping-progress-bar').width("100%");
            } else {
                $('[data-free-shipping-text]').html("<p>You are <span>" +
                    amountToFreeShipping +
                    " Away</span> from U.S. Free Shipping</p>");
                $('.shipping-progress-bar').width((subtotal / shippingThreshold * 100) + "%");
            }
            $('.free-shipping-progress-bar').removeClass('hide');
        },

        _setCartCountBubble: function (quantity) {
            this.$cartCountBubble =
                this.$cartCountBubble || $(this.selectors.cartCountBubble);
            this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

            this.$cartCountBubble.removeClass(this.classes.hidden);
            this.$cartCount.text(quantity);
        },

        _showCartPopup: function () {
            $('.cart-overlay').removeClass('cart-overlay--hidden');
            this.$cartPopupWrapper
                .prepareTransition()
                .removeClass(this.classes.cartPopupWrapperHidden);
            this._handleButtonLoadingState(false);

            slate.a11y.trapFocus({
                $container: this.$cartPopupWrapper,
                $elementToFocus: this.$cartPopup,
                namespace: "cartPopupFocus"
            });
        },

        _hideCartPopup: function (event) {
            var setFocus = event.detail === 0 ? true : false;
            $('.cart-overlay').addClass('cart-overlay--hidden');
            this.$cartPopupWrapper
                .prepareTransition()
                .addClass(this.classes.cartPopupWrapperHidden);

            $(this.selectors.cartPopupImage).remove();
            this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

            slate.a11y.removeTrapFocus({
                $container: this.$cartPopupWrapper,
                namespace: "cartPopupFocus"
            });

            // if (setFocus) this.$previouslyFocusedElement[0].focus();
        },

        _onBodyClick: function (event) {
            var $target = $(event.target);

            if (
                $target[0] !== this.$cartPopupWrapper[0] && $target[0] !== this.$cartPopupOpen[0] && $target[0] !== this.$cartPopupOpenMobile[0] &&
                !$target.parents(this.selectors.cartPopup).length
            ) {
                this._hideCartPopup(event);
            }
        },

        _updateAddToCart: function (evt) {
            var variant = evt.variant;

            if (variant) {
                if (variant.available) {
                    this.$addToCart
                        .removeAttr("aria-disabled")
                        .attr("aria-label", theme.strings.addToCart);
                    $(this.selectors.addToCartText, this.$container).text(
                        theme.strings.addToCart
                    );
                    this.$shopifyPaymentButton.show();
                } else {
                    // The variant doesn't exist, disable submit button and change the text.
                    // This may be an error or notice that a specific variant is not available.
                    this.$addToCart
                        .attr("aria-disabled", true)
                        .attr("aria-label", theme.strings.soldOut);
                    $(this.selectors.addToCartText, this.$container).text(
                        theme.strings.soldOut
                    );
                    this.$shopifyPaymentButton.hide();
                }
            } else {
                this.$addToCart
                    .attr("aria-disabled", true)
                    .attr("aria-label", theme.strings.unavailable);
                $(this.selectors.addToCartText, this.$container).text(
                    theme.strings.unavailable
                );
                this.$shopifyPaymentButton.hide();
            }
        }
    });

    return ProductCard;
})();

theme.ProductVideo = (function () {
    var selectors = {
        playButton: ".product-video__button",
        iframeWrapper: ".product-video__iframe-wrapper",
        iframe: ".product-video__iframe",
        contentOverlay: ".product-video__overlay",
        videoThumbnail: ".product-video__thumbnail"
    };

    var classes = {
        showIframe: "product-video__iframe--show"
    };

    function ProductVideo(container) {
        $(selectors.playButton).on("click", function (e) {
            e.preventDefault();

            var videoId = $(selectors.iframeWrapper).data("video-id");
            var videoSrc =
                "https://player.vimeo.com/video/" +
                videoId +
                "?autoplay=1&title=0&byline=0&portrait=0";

            $(selectors.iframe).attr("src", videoSrc);
            $(selectors.iframe).addClass(classes.showIframe);
            $(selectors.contentOverlay).fadeOut("slow");

            // Timeout necessary for smooth transition before video loads
            setTimeout(function () {
                $(selectors.videoThumbnail).fadeOut("slow");
            }, 600);
        });
    }

    return ProductVideo;
})();

theme.Tabs = (function () {
    function Tabs(container) {
        var $container = (this.$container = $(container));
        var $tabs = $("[data-atabs]", $container);

        new ARIAtabs($tabs[0]);
    }

    return Tabs;
})();

theme.HeroVideo = (function () {
    var selectors = {
        hero: "#VideoHero",
        video: "#VideoHeroVideo",
        image: "#VideoHeroImage",
        videoControls: ".hero-video__controls",
        videoControlsLabel: ".hero-video__controls-label"
    };

    var classes = {
        videoControlsPlaying: "hero-video__controls--playing",
        videoControlsPaused: "hero-video__controls--paused"
    };

    function HeroVideo(container) {
        var $container = (this.$container = $(container));

        this.$hero = document.querySelector(selectors.hero, $container);
        this.$video = document.querySelector(selectors.video);
        this.$image = document.querySelector(selectors.image, $container);
        this.$videoControls = document.querySelector(
            selectors.videoControls,
            $container
        );
        this.$videoControlsLabel = document.querySelector(
            selectors.videoControlsLabel,
            $container
        );
        this.viewPort = this._getViewport();
        this.videoUrl;
        this.mobileVideoUrl = this.$video.getAttribute("data-mobile-src");

        // Get video URL based on viewport and if a mobile URL has been specified
        if (this.viewPort === "desktop" || this.mobileVideoUrl === null) {
            this.videoUrl = this.$video ? this.$video.getAttribute("data-src") : null;
        } else if (this.viewPort === "mobile" && this.mobileVideoUrl !== null) {
            this.videoUrl = this.$video
                ? this.$video.getAttribute("data-mobile-src")
                : null;
        }

        if (this._playsVideo()) {
            this._showVideo();
        } else {
            this._showImage();
        }

        this.$hero.addEventListener(
            "click",
            this._controlVideoOnClick.bind(this, event)
        );
    }

    HeroVideo.prototype = _.assignIn({}, HeroVideo.prototype, {
        _getViewport: function () {
            if (window.matchMedia("(max-width: 767px)").matches) {
                return "mobile";
            } else {
                return "desktop";
            }
        },

        _showVideo: function () {
            this.$video.innerHTML =
                '<source src="' + this.videoUrl + '" type="video/mp4">';
            this.$video.classList.remove("hide");
            if (this.$image) {
                this.$image.classList.add("hide");
            }
        },

        _controlVideoOnClick: function () {
            // First condition so doesn't break on IE if clicked element has no classes
            if (
                event.target.classList !== null ||
                !event.target.classList.contains("hero__btn")
            ) {
                if (this.$video.paused) {
                    this.$video.play();
                    this.$videoControlsLabel.textContent = "Pause video";
                    this.$videoControls.setAttribute("aria-label", "Pause video");
                    this.$videoControls.classList.add(classes.videoControlsPlaying);
                    this.$videoControls.classList.remove(classes.videoControlsPaused);
                } else {
                    this.$video.pause();
                    this.$videoControlsLabel.textContent = "Play video";
                    this.$videoControls.setAttribute("aria-label", "Play video");
                    this.$videoControls.classList.add(classes.videoControlsPaused);
                    this.$videoControls.classList.remove(classes.videoControlsPlaying);
                }
            }
        },

        _showImage: function () {
            this.$image.classList.remove("hide");
            if (this.$video) {
                this.$video.classList.add("hide");
            }
        },

        _playsVideo: function () {
            var isPlaying;

            if (!this.$video || !this.videoUrl) {
                return false;
            }

            isPlaying = true;
            this.$video.src = this.videoUrl;
            this.$video.play();

            return isPlaying;
        }
    });

    return HeroVideo;
})();

theme.FeatureReview = (function () {
    var selectors = {
        reviewSlideshow: ".feature-review__slideshow",
        slickList: ".slick-list"
    };

    function FeatureReview(container) {
        // Remove Aria live attribute due to autoplay
        $(selectors.reviewSlideshow).on("init", function () {
            $(selectors.reviewSlideshow)
                .find(selectors.slickList)
                .removeAttr("aria-live");
        });

        $(selectors.reviewSlideshow).slick({
            fade: true,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false
        });
    }

    return FeatureReview;
})();

theme.ReviewsWithFilters = (function () {
    var selectors = {
        filtersWrapper: '.reviews-with-filters__list',
        sliderWrapper: '.reviews-with-filters__slider-wrapper'
    };
    if ($(selectors.sliderWrapper).length > 0) {
        function initReviewsSlider(selectedFilter) {
            let reviews = [];
            if (selectedFilter) {
                $('.reviews-with-filters__slider-wrapper').attr('data-filters-type', 'selected');
                $.each(reviews_data, function (key, val) {
                    if (val.tags.indexOf(selectedFilter) >= 0) {
                        reviews.push(this);
                    }
                })
            }

            if (reviews.length == 0) {
                reviews = reviews_data;
                $('.reviews-with-filters__slider-wrapper').attr('data-filters-type', 'all');
            }

            $(selectors.sliderWrapper).html('<ul></ul>');

            $.each(reviews, function (key, val) {
                let reviewSlide = `<li class="reviews-with-filters__slide-item">
          <div class="reviews-with-filters__content">
            <img class="lazyload" width="66px" height="66px" data-src="`+ $(selectors.filtersWrapper).find('li.active img').attr('data-src') + `" />
            `+ review_stars + `
            `+ val.text + `
            <span>`+ val.source + `</span>
          </div>
          <div class="reviews-with-filters__product-details">
          <img class="lazyload" alt="`+ val.product[0].title + `" data-src="` + val.product[0].image + `" />
          <div>
            <p>`+ val.product[0].title + `</p>
            <span>`+ val.product[0].subtext + `</span>
          </div>
          </div>
        </li>`
                $(selectors.sliderWrapper).find('ul').append(reviewSlide);
            });

            $(selectors.sliderWrapper).find('ul').slick({
                slidesToScroll: 1,
                slidesToShow: 3,
                arrows: true,
                dots: false,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            infinite: true
                        }
                    }
                ]
            })
        }

        $(selectors.filtersWrapper).find('li:first-child').addClass('active');
        initReviewsSlider($(selectors.filtersWrapper).find('li.active').data('filter-id'));

        $(selectors.filtersWrapper).find('li').on('click', function () {
            $(this).addClass('active').siblings().removeClass('active');
            initReviewsSlider($(selectors.filtersWrapper).find('li.active').data('filter-id'));
        });
    }

})();

theme.VideosText = (function () {
    var selectors = {
        videosWithText: ".videos-with-text"
    };

    if ($(selectors.videosWithText).length > 0) {
        $(selectors.videosWithText).each(function () {
            let $this = $(this);
            let videosParent = $(this).find('.videos-with-text__media')
            let videos = $this.find('video');
            let listParent = $this.find('.videos-with-text__list');
            let lists = $this.find('.videos-with-text__list li');
            let index = 0;
            let mobileProgressBar = $('.mobile-progress-bar-wrapper .mobile-progress-bar')

            function videosProgress(i) {
                lists.eq(i).siblings().find('.track').hide().css("height", 0)
                lists.eq(i).find('.track').show();
                lists.eq(i).siblings().find('.videos-with-text__list-content').removeClass('active');
                lists.eq(i).find('.videos-with-text__list-content').addClass('active');
                mobileProgressBar.eq(i).siblings().find('.track').hide().css("width", 0)
                mobileProgressBar.eq(i).find('.track').show();
                // videos.eq(i).closest('div').show().siblings().hide();
                videos[i].play();
                videos[i].ontimeupdate = function () {
                    var percentage = (videos[i].currentTime / videos[i].duration) * 100;
                    lists.eq(i).find('.track').css("height", percentage + "%");
                    mobileProgressBar.eq(i).find('.track').css("width", percentage + "%");
                };
                videos[i].onended = function () {
                    // index++;
                    videosParent.slick('slickNext');
                    // if(index >= videos.length){
                    //   index = 0;
                    // }
                    // videosProgress(index);
                };
            }

            if ($(window).width() > 767) {
                lists.on('click', function () {
                    videosParent.slick('slickGoTo', $(this).index());
                });
            }

            videosParent.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                index = parseInt(videosParent.find('.slick-active').data('media-index'));
                videosParent.find('video').each(function () {
                    $(this)[0].pause();
                    $(this)[0].currentTime = 0;
                });
                videosProgress(index);
            });

            videosParent.on('init', function (event, slick, currentSlide, nextSlide) {
                index = parseInt(videosParent.find('.slick-active').data('media-index'));
                videosParent.find('video').each(function () {
                    $(this)[0].pause();
                    $(this)[0].currentTime = 0;
                });
                videosProgress(index);
            });

            videosParent.slick({
                arrows: false,
                dots: false,
                fade: true,
                resonsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            asNavFor: listParent
                        }
                    }
                ]
            })

            if ($(window).width() < 768) {
                listParent.slick({
                    dots: false,
                    arrows: true,
                    asNavFor: videosParent,
                    nextArrow: `<button type="button" class="slick-arrow slick-next"><svg width="6" height="13" viewBox="0 0 6 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.136871 11.7465C-0.0501733 11.9621 -0.0448456 12.3058 0.148771 12.5141C0.342387 12.7224 0.650974 12.7164 0.838018 12.5008L5.86313 6.70782C6.04568 6.49738 6.04562 6.16366 5.86298 5.95331L0.837871 0.16535C0.650742 -0.0501862 0.342153 -0.0559692 0.148618 0.152432C-0.0449166 0.360834 -0.0501099 0.704503 0.137019 0.920039L4.83466 6.33081L0.136871 11.7465Z" fill="#1C3321"/>
          </svg></button>`,
                    prevArrow: `<button type="button" class="slick-arrow slick-prev"><svg width="6" height="13" viewBox="0 0 6 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.86313 11.7465C6.05017 11.9621 6.04485 12.3058 5.85123 12.5141C5.65761 12.7224 5.34903 12.7164 5.16198 12.5008L0.136871 6.70782C-0.0456807 6.49738 -0.0456155 6.16366 0.137018 5.95331L5.16213 0.16535C5.34926 -0.0501862 5.65785 -0.0559692 5.85138 0.152432C6.04492 0.360834 6.05011 0.704503 5.86298 0.920039L1.16534 6.33081L5.86313 11.7465Z" fill="#1C3321"/>
          </svg></button>`
                })
            } else {
                // videosProgress(index);
            }

        });
    }
})();

window.theme = window.theme || {};

theme.ProductRecommendations = (function () {
    var classes = {
        hiddenProductCard: "product-recommendations__product-card--hidden"
    };

    var selectors = {
        productCard: ".product-recommendations__product-card"
    };

    function ProductRecommendations(container) {
        this.$container = $(container);

        // console.log(this.$container);

        const productId = this.$container.data("productId");
        const limit = this.$container.data("limit");
        const heading = this.$container.data("heading");
        const view = this.$container.data("view");
        const mobileLayout = this.$container.data("mobileLayout");
        const desktopLayout = this.$container.data("desktopLayout");

        const recommendationsSectionUrl = `/recommendations/products?product_id=${productId}&limit=${limit}&section_id=product-recommendations&heading=${heading}&view=${view}&desktopLayout=${desktopLayout}&mobileLayout=${mobileLayout}`;

        $.get(recommendationsSectionUrl)
            .then(
                function (section) {
                    // console.log("ProductRecommendations from alt-dot-custom.js");
                    // console.log($(section));
                    var recommendationsMarkup = $(section).html();
                    if (recommendationsMarkup.trim() !== "") {
                        this.$container.html(recommendationsMarkup);
                        window.sections.register('product-card', theme.ProductCard);
                    }
                }.bind(this)
            )
            .then(function () {
                // Find and hide any product cards with the same title as the current product
                var currentProductTitle = $(container).data("product-title");
                var $productCardTitleMatch = $(
                    selectors.productCard +
                    '[data-recommended-product-title="' +
                    currentProductTitle +
                    '"]'
                );
                $productCardTitleMatch.addClass(classes.hiddenProductCard);

                // Find and hide any product cards containing "Gift" in the title
                var $productCardGift = $(
                    selectors.productCard + '[data-recommended-product-title*="Gift"]'
                );
                $productCardGift.addClass(classes.hiddenProductCard);

                // Find and hide duplicate the-makeup-bag product
                var $productMakeupBag = $(
                    selectors.productCard + '[data-recommended-product-id*="6671975153722"]'
                );
                $productMakeupBag.addClass(classes.hiddenProductCard);

                // Hide all visible product cards beyond the limit
                var $visibleCards = $(`${selectors.productCard}:not(.${classes.hiddenProductCard}):gt(${limit})`);
                $visibleCards.addClass(classes.hiddenProductCard);
            });
    }

    return ProductRecommendations;
})();

/**
 * Conditionally shows backorder messages on product pages based on selected SKU.
 */
theme.ProductBackorderMessage = (function () {
    /**
     * Handles a single product section on the product page.
     * E.g. regular, subscription, or mini
     */
    function SingleProductMessage(container) {
        this.$container = $(container);

        // Message content is set up in the template.
        this.$message = this.$container.find("[data-backorder-message]");
        this.$buttonMessage = this.$container.find(
            "[data-button-backorder-message]"
        );

        // // We save the ship date in a line item property to be shown on
        // // the cart page and in checkout.
        this.$shipDateProperty = $(
            '<input type="hidden" name="properties[Ship Date]" value="">'
        );
        this.$container.find(".product-form").append(this.$shipDateProperty);

        // Listen to change events from theme.Product().
        this.$container.on("variantChange", this.onVariantChange.bind(this));

        // Messages start hidden - unhide them if necessary.
        this.updateMessages(this.$container.data("initial-sku"));
    }

    SingleProductMessage.prototype = _.assignIn(
        {},
        SingleProductMessage.prototype,
        {
            /**
             * Event handler for variantChange events.
             */
            onVariantChange: function (event) {
                if (event.variant) {
                    this.updateMessages(event.variant.sku);
                }
            },

            /**
             * Updates message visibility based on currently selected SKU.
             */
            updateMessages: function (sku) {
                var backorderSkuList = this.$message.data("backorder-skus") || [];
                var backorderShipDate = this.$message.data("backorder-ship-date");
                var isBackorderVariant = backorderSkuList.indexOf(sku) > -1;
                var shipDatePropertyValue = isBackorderVariant ? backorderShipDate : "";

                // // Show or hide the messages.
                this.$message.toggle(isBackorderVariant);
                this.$buttonMessage.toggle(isBackorderVariant);

                // // Update the line item property.
                this.$shipDateProperty.attr("value", shipDatePropertyValue);
            },
        }
    );

    /**
     * Sets up all product sections on the product page.
     * E.g. regular, subscription, or mini
     */
    function ProductPageMessages(container) {
        $(container)
            .find('[data-section-type="product"]')
            .each(function () {
                return new SingleProductMessage(this);
            });
    }

    return ProductPageMessages;
})();

theme.KlaviyoSignUpForm = (function () {
    let formSelector = $('.klaviyo__form form');
    let checkboxSelector = formSelector.find('input[type="checkbox"]');
    checkboxSelector.on('change', function () {
        if (checkboxSelector.is(':checked')) {
            formSelector.find('button').removeAttr('disabled')
        } else {
            formSelector.find('button').attr('disabled', 'disabled')
        }
    })

    formSelector.on('submit', function (e) {
        e.preventDefault();
        let $form = $(this);
        let $button = $(this).find('button');
        let $originalText = $button.text();
        let $phoneVal = $form.find('[name="phone-number"]').val();
        if ($phoneVal.indexOf('+') > 0 || $phoneVal.indexOf('+') < 0) {
            alert('Please add + and country code, e.g. +12345678910');
            return false;
        }

        $button.text('Please wait...').css('pointer-events', 'none');

        var formSettings = {
            "async": true,
            "crossDomain": true,
            "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
            "method": "POST",
            "headers": {
                "content-type": "application/x-www-form-urlencoded",
                "cache-control": "no-cache"
            },
            "data": {
                "g": $form.data('list-id'),
                "$fields": "$phone,$source",
                "email": $form.find('[name="email"]').val(),
                "phone_number": $form.find('[name="phone-number"]').val()
            }
        }

        $.ajax(formSettings).done(
            function
                (response) {
                $button.text($originalText).css('pointer-events', 'all');
                $('.klaviyo__form form').html('<div>' + $form.data('success-msg') + '</div>');
            });
    });

    // return KlaviyoSignUpForm;
})();

// Items in the lib folder will be compiled first. Put any dependencies your code depends on there.
$(document).ready(function () {
    window.sections.register("cart-gift", theme.CartGift);
    window.sections.register("product-card", theme.ProductCard);
    window.sections.register("tabs", theme.Tabs);
    window.sections.register("product-single", theme.ProductToggle);
    window.sections.register("product-single", theme.ProductBackorderMessage);
    window.sections.register("product-video", theme.ProductVideo);
    window.sections.register("hero-video", theme.HeroVideo);
    window.sections.register("feature-review", theme.FeatureReview);
    window.sections.register("index-reviews-with-filters", theme.ReviewsWithFilters);
    window.sections.register("index-videos-text", theme.VideosText);
    window.sections.register("sign-up-form", theme.KlaviyoSignUpForm);
});

//Scroll to section
$(document).on('click', '.scroll_to_section[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 100
    }, 500);
});
